//node_modules
import React from "react";
import { NextPage } from "next";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

//types
import type { PageProps } from "./types";

//layout
import SiteLayout from "src/layouts/SiteLayout";

//components
import StaticBackgroundComponent from "@adjust/website/src/components/StaticBackgroundComponent";
import ParallaxHeaderComponent from "@adjust/website/src/components/ParallaxHeaderComponent";
import PageHeaderComponent from "@adjust/website/src/components/PageHeaderComponent";
import NextLink from "@adjust/website/src/components/NextLink";

//locals
import StatementComponent from "./components/StatementComponent";
import TravelPlanComponent from "./components/TravelPlanComponent";
import TestimonialCarouselComponent from "./components/TestimonialCarouselComponent";
import PartnersAffiliatesComponent from "./components/PartnersAffiliatesComponent";
import MetaDataComponent from "./components/MetaDataComponent";

//images
import parallax1 from "@adjust/public/images/97b9375cf75ade65090bccc8c8ef5884.png";
import parallax2 from "@adjust/public/images/f8f8e0309fcf757da2220e09081f9e54.png";

//styles
import { cx, minHeight594CSS, width18emCSS } from "@adjust/website/src/styles/shared";

const HomePage: NextPage<PageProps> = ({ testimonials }) => {
  return (
    <SiteLayout>
      <MetaDataComponent />
      <StaticBackgroundComponent bgImage={parallax1} bgImageAlt="Mountains" fetchPriority="high" priority>
        <ParallaxHeaderComponent>
          Adjust to the Good Life Travel is a Raleigh, North Carolina based travel agency, where we specialize in turning your travel dreams into memorable vacations!
        </ParallaxHeaderComponent>
      </StaticBackgroundComponent>
      <StatementComponent />
      <TravelPlanComponent />
      <StaticBackgroundComponent bgImage={parallax2} bgImageAlt="Oceans" fetchPriority="low">
        <Container className="my-5">
          <Row className={cx(minHeight594CSS, "g-0", "text-center")}>
            <Col md={6} className="my-auto d-flex">
              <Card className={cx(width18emCSS, "mx-auto", "border-dark")}>
                <Card.Body>
                  <Card.Title>
                    <PageHeaderComponent type="p" className="text-center">
                      Ready to get started?
                    </PageHeaderComponent>
                  </Card.Title>
                  <Card.Text>
                    Let my travel experience help to plan <b>your vacation!</b>
                  </Card.Text>
                  <Row className="g-0">
                    <NextLink href="/contact">
                      <Button variant="outline-primary">CONTACT US</Button>
                    </NextLink>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} className="my-auto d-flex">
              <Card className={cx(width18emCSS, "mx-auto", "border-dark")}>
                <Card.Body>
                  <Card.Title>
                    <PageHeaderComponent type="p" className="text-center">
                      Sandals Resorts
                    </PageHeaderComponent>
                  </Card.Title>
                  <Card.Text>
                    <b>More quality inclusions</b> than any other resorts on the planet
                  </Card.Text>
                  <Row className="g-0">
                    <NextLink href="/sandals-beaches-resorts">
                      <Button variant="outline-primary">LOOK CLOSER</Button>
                    </NextLink>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </StaticBackgroundComponent>
      <TestimonialCarouselComponent testimonials={testimonials} />
      <PartnersAffiliatesComponent />
    </SiteLayout>
  );
};

export default HomePage;
